import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2b7ff8eb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "PriceCalculateQuestionSelectorContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "价值计算", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft14 ml16 mr4"
}, "题目数量:", -1));
const _hoisted_4 = {
  class: "ft14",
  style: {
    "color": "#1388ff"
  }
};
const _hoisted_5 = {
  class: "mr16"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "A", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "B", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "C", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LeftGroupList = _resolveComponent("LeftGroupList");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_PriceCalculateImage = _resolveComponent("PriceCalculateImage");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_row, {
    class: "mt12"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      class: "wbg flex flex-col wd100",
      style: {
        "height": "100%"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_LeftGroupList, {
        "group-title": "价值计算分组",
        data: $data.groups,
        onChoose: $options.onChoose
      }, null, 8, ["data", "onChoose"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 20,
      class: "opd12 flex flex-col"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "pd12 wbg flex items-center"
      }, {
        default: _withCtx(() => [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString($data.questions.length), 1)]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questions, (q, qi) => {
        return _openBlock(), _createBlock(_component_el_row, {
          key: q.id,
          class: "wbg mt12 pd12 flex flex-col",
          style: {
            "border": "#1388ff 1px dashed"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            class: "ft14 flex items-center"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_5, "第" + _toDisplayString(qi + 1) + "题 ", 1), _createVNode(_component_el_button, {
              type: "primary",
              onClick: $event => _ctx.$emit('confirm', q.id)
            }, {
              default: _withCtx(() => [_createTextVNode("选择此题")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1024), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.questions, (q, qi) => {
              return _openBlock(), _createBlock(_component_PriceCalculateImage, {
                key: `sq_${qi}`,
                data: q
              }, null, 8, ["data"]);
            }), 128))]),
            _: 2
          }, 1024), _createVNode(_component_el_row, {
            style: {
              "align-items": "flex-end"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "flex flex-col flex items-center justify-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_PriceCalculateImage, {
                data: q.optionA
              }, null, 8, ["data"]), _hoisted_6]),
              _: 2
            }, 1024), _createVNode(_component_el_row, {
              class: "flex flex-col flex items-center justify-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_PriceCalculateImage, {
                data: q.optionB
              }, null, 8, ["data"]), _hoisted_7]),
              _: 2
            }, 1024), _createVNode(_component_el_row, {
              class: "flex flex-col flex items-center justify-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_PriceCalculateImage, {
                data: q.optionC
              }, null, 8, ["data"]), _hoisted_8]),
              _: 2
            }, 1024), _createVNode(_component_el_row, {
              class: "flex flex-col flex items-center justify-center"
            }, {
              default: _withCtx(() => [_createVNode(_component_PriceCalculateImage, {
                data: q.optionD
              }, null, 8, ["data"]), _hoisted_9]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024), _createElementVNode("span", null, "答案：" + _toDisplayString(q.rightAnswer), 1)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })]),
    _: 1
  })]);
}